// App.jsx
import { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  Outlet
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Sidebar from "./components/Sidebar";
import AuthWrapper from "./components/AuthWrapper";
import NotAuthorized from "./components/notAuthorized";
import UserProfileBar from "./components/UserProfilebar";

import LoginPage from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";
import Items from "./pages/Items";
import AddCategory from "./pages/AddCategory";
import AddItem from "./pages/AddItem";
import EditScreen from "./pages/EditItem";
import Employee from "./pages/employee";
import ExcelImport from "./pages/ExcelImport";
import EmployeeTable from "./components/EmployeeTable";
import EmployeeMaster from "./pages/EmployeeMaster";
import EditEmployee from "./pages/editEmployee";
import OrderDetails from "./pages/OrderDetails";
import OrderSummary from "./components/OrderSummary";
import ServiceScreen from "./components/ServiceScreen";
import ServiceList from "./pages/ServiceList";
import AddServiceCategory from "./pages/AddServiceCategory";
import UpdateItems from "./components/UpdateItemsCSV";
import APIURL from "./api/apiClient";
import OfferPage from "./pages/AddOffers";
import ItemActionScreen from "./pages/ItemsBulkActions";
import ItemActions from "./pages/ItemsBulkActions";
import OffersTable from "./pages/OfferItemsAll";
import OfferBannerList from "./pages/OfferBannerList";
import SendNotification from "./pages/SendNotification";
import StaffOnly from "./staff/page";

const Container = styled.div`
  display: flex;
  min-height: 100vh;
`;

const MainContent = styled.div`
  flex: 1;
  padding: 20px;
  margin-left: ${({ sidebarVisible }) => (sidebarVisible ? "260px" : "0")};
  transition: margin-left 0.3s ease-in-out;
`;

const PublicRoute = ({ children }) => {
  return <div className="public-route">{children}</div>;
};

const LayoutWithHeader = ({ children }) => {
  return (
    <div>
      <header
        style={{
          // padding: "5px 10px",
          backgroundColor: "transparent",
          color: "white",
          // display: "flex",
          // justifyContent: "flex-end",
        }}
      >
        {/* <UserProfileBar /> */}
      </header>
      {children}
    </div>
  );
};

const ProtectedRoute = ({ children, allowedRoles = ["admin", "employee"] }) => {
 const [sidebarVisible, setSidebarVisible] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(null);
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole");
  const [lastOrderId, setLastOrderId] = useState(null);
  const [newOrderId, setNewOrderId] = useState(null);

  // useEffect(() => {
  //   const verifySession = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${APIURL.baseURL}/session.php`,
  //         { withCredentials: true }
  //       );

  //       if (response.data.loggedIn && allowedRoles.includes(response.data.role)) {
  //         setIsAuthorized(true);
  //       } else {
  //         localStorage.removeItem("userRole");
  //         setIsAuthorized(false);
  //         navigate("/not-authorized", { replace: true });
  //       }
  //     } catch (err) {
  //       localStorage.removeItem("userRole");
  //       setIsAuthorized(false);
  //       navigate("/login", { replace: true });
  //     }
  //   };

  //   verifySession();
  // }, [navigate, allowedRoles]);

  useEffect(() => {
  const verifySession = async () => {
    try {
      const response = await axios.get(`${APIURL.baseURL}/session.php`, { withCredentials: true });
      const { loggedIn, role } = response.data;

      if (loggedIn && allowedRoles.includes(role)) {
        setIsAuthorized(true);

        // ✅ Hide sidebar for staff
        if (role === "staff") {
          setSidebarVisible(false);
        } else {
          setSidebarVisible(true);
        }
      } else {
        localStorage.removeItem("userRole");
        setIsAuthorized(false);
        navigate("/not-authorized", { replace: true });
      }
    } catch (err) {
      localStorage.removeItem("userRole");
      setIsAuthorized(false);
      navigate("/login", { replace: true });
    }
  };

  verifySession();
}, [navigate, allowedRoles]);


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(
          `${APIURL.baseURL}/fetchorders.php`
        );
        let orders = response.data;

        if (orders.length > 0) {
          const latestOrderId = orders[orders.length - 1].order_id;

          if (lastOrderId === null) {
            setLastOrderId(latestOrderId);
          } else if (latestOrderId !== lastOrderId) {
            setLastOrderId(latestOrderId);
            setNewOrderId(latestOrderId);
            toast.info(`🛒 New order received! ID: ${latestOrderId}`);
            setTimeout(() => setNewOrderId(null), 5000);
          }
        }
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    fetchOrders();
    const interval = setInterval(fetchOrders, 10000);
    return () => clearInterval(interval);
  }, [lastOrderId]);

  if (isAuthorized === null) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Container>
      {sidebarVisible && <Sidebar userRole={userRole} />}
      <MainContent sidebarVisible={sidebarVisible}>
        <LayoutWithHeader>{children}</LayoutWithHeader>
      </MainContent>
    </Container>
  );
};

const App = () => {
  return (
    <Router>
      <AuthWrapper>
        <ToastContainer position="top-right" autoClose={3000} />

        <Routes>
          <Route path="/" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/not-authorized" element={<PublicRoute><NotAuthorized /></PublicRoute>} />

          {/* Common protected routes */}
          <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
          <Route path="/items" element={<ProtectedRoute><Items /></ProtectedRoute>} />
          <Route path="/addcategory" element={<ProtectedRoute><AddCategory /></ProtectedRoute>} />
          <Route path="/additem" element={<ProtectedRoute><AddItem /></ProtectedRoute>} />
          <Route path="/edit/:id" element={<ProtectedRoute><EditScreen /></ProtectedRoute>} />
          <Route path="/orderdetails" element={<ProtectedRoute><OrderDetails /></ProtectedRoute>} />
          <Route path="/ordersummary/:id" element={<ProtectedRoute><OrderSummary /></ProtectedRoute>} />
          <Route path="/servicescreen/:id" element={<ProtectedRoute><ServiceScreen /></ProtectedRoute>} />
          <Route path="/servicelist" element={<ProtectedRoute><ServiceList /></ProtectedRoute>} />
          <Route path="/servicecategory" element={<ProtectedRoute><AddServiceCategory /></ProtectedRoute>} />
          <Route path="/offeritemsall" element={<ProtectedRoute><OffersTable /></ProtectedRoute>} />
          <Route path="/offerbannerlists" element={<ProtectedRoute><OfferBannerList /></ProtectedRoute>} />
          <Route path="/addoffers" element={<ProtectedRoute><OfferPage /></ProtectedRoute>} />

          {/* Admin-only routes */}
          <Route path="/itemactions" element={<ProtectedRoute allowedRoles={["admin"]}><ItemActions /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute allowedRoles={["admin"]}><SendNotification /></ProtectedRoute>} />
          <Route path="/employee" element={<ProtectedRoute allowedRoles={["admin"]}><Employee /></ProtectedRoute>} />
          <Route path="/excelimport" element={<ProtectedRoute allowedRoles={["admin",]}><ExcelImport /></ProtectedRoute>} />
          <Route path="/updateitemscsv" element={<ProtectedRoute allowedRoles={["admin", "staff"]}><UpdateItems /></ProtectedRoute>} />
          <Route path="/employeetable" element={<ProtectedRoute allowedRoles={["admin"]}><EmployeeTable /></ProtectedRoute>} />
          <Route path="/employeemaster" element={<ProtectedRoute allowedRoles={["admin"]}><EmployeeMaster /></ProtectedRoute>} />
          <Route path="/editEmployee/:id" element={<ProtectedRoute allowedRoles={["admin"]}><EditEmployee /></ProtectedRoute>} />

          {/* Staff only routes */}
          <Route
            path="/staffscreen"
            element={
              <ProtectedRoute allowedRoles={["staff", "admin"]}>
                <StaffOnly />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthWrapper>
    </Router>
  );
};

export default App;
